<template>
  <div class="xcard">
    <div class="row">
      <div class="col-sm-5"> 
        <input class="btn btn-sm" type="file" id="fileUpload" />
      </div>
      <div class="col-sm-6">
        <input class="btn btn-sm btn-success" type="button" id="upload" value="Visualizar" @click="Upload()" />
      </div>
    </div>
    <hr />

    <div class="table-responsive">
      <table class="table table-condensed">
        <thead>
          <tr>
            <th> <small>Nro</small> </th>
            <th style="min-width:150px"> <small>Estado</small> </th>
            <th> <small>Documento</small> </th>
            <th> <small>Nombres</small> </th>
            <th> <small>Apellido_1</small> </th>
            <th> <small>Apellido_2</small> </th>
            <th> <small>Telefono</small> </th>
            <th> <small>Correo</small> </th>
            <th> <small>Genero</small> </th>
            <th> <small>Usuario Moodle</small> </th>
            <th> <small>Clave Moodle</small> </th>
            <th> <small>Departamento (Carnet)</small> </th>
            <th> <small>Profesion</small> </th>
            <th> <small>Ciudad Residencia</small> </th>
          </tr>
        </thead>

        <tbody>
          <tr :key="ind" v-for="(e,ind) in estudiantes">
            <td> <small> {{ind+1}} </small> </td>
            <td> <small> {{e.estado}} </small> </td>
            <td> <small> {{e.num_doc}} </small> </td>
            <td> <small> {{e.nombres}} </small> </td>
            <td> <small> {{e.pri_apellido}} </small> </td>
            <td> <small> {{e.seg_apellido}} </small> </td>
            <td> <small> {{e.telefono1}} </small> </td>
            <td> <small> {{e.email}} </small> </td>
            <td> <small> {{e.sexo}} </small> </td>
            <td> <input type="text" v-model="e.usuario_moodle" style="border: 0;"> </td>
            <td> <input type="text" v-model="e.clave_moodle" style="border: 0;"> </td>
            <td> <small> {{e.iddepartamento}} </small> </td>
            <td> <small> {{e.profesiones[0]}} </small> </td>
            <td> <small> {{e.idciudad}} </small> </td>
          </tr>
        </tbody>
      </table>

      <button v-if="estudiantes.length>0" :disabled="subiendo" class="btn btn-sm btn-azul" @click="subir()"> Subir estudiantes </button>
    </div>
    <p class="text-center text-info"> <small>{{msg}}</small> </p>
    <Codigos id="codigos" :obj="modeldatos"/>
    <div id="dvExcel">
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { parseJsonError,getCleanedString } from '@/components/Utils.js'
import Codigos from '@/components/AExcelInsCodigos.vue'
// import {parseJsonError} from '@/components/Utils.js'

export default {
  data(){
    return{
      modeldatos: {xtitle:'',xbody:'',xsql:''},
      subiendo: false,
      msg:'',
      estudiantes:[],
      getCiudades:[],
      getProfesiones:[],
      getDepartamentos:[],
    }
  },
  components:{ Codigos },
  methods:{
    crearLogin( a, ap, am ){
      var inicial = "";
      var aa = "";
      var mm = "";
      if( a && a.length > 0 ){ inicial = a.substring(0,1); }
      if( ap && ap.length > 0 ){ aa = ap.replace(/\s+/g, ""); }
      if( am && am.length > 0 ){ mm = am.replace(/\s+/g, ""); }
      var logi = inicial + aa+ mm;
      logi = getCleanedString(logi);
      return logi;
    },
    crearClave( car,dep ){
      var ci = "";
      if( car && car.length > 0 ) ci = car;
      if( dep ) ci = ci+dep.extension;
      return ci;
    },
    Upload() {
       var vue = this;
        //Reference the FileUpload element.
        var fileUpload = document.getElementById("fileUpload");
 
        //Validate whether File is valid Excel file.
        var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
        if (regex.test(fileUpload.value.toLowerCase())) {
            if (typeof (FileReader) != "undefined") {
                var reader = new FileReader();
 
                //For Browsers other than IE.
                if (reader.readAsBinaryString) {
                    reader.onload = function (e) {
                        vue.processExcel(e.target.result);
                    };
                    reader.readAsBinaryString(fileUpload.files[0]);
                } else {
                    //For IE Browser.
                    reader.onload = function (e) {
                        var data = "";
                        var bytes = new Uint8Array(e.target.result);
                        for (var i = 0; i < bytes.byteLength; i++) {
                            data += String.fromCharCode(bytes[i]);
                        }
                        vue.processExcel(data);
                    };
                    reader.readAsArrayBuffer(fileUpload.files[0]);
                }
            } else {
                alert("This browser does not support HTML5.");
            }
        } else {
            alert("Por favor seleccione un archivo excel valido.");
        }
    },
    processExcel(data) {
      var vue = this;
        var workbook = window.XLSX.read(data, {
            type: 'binary'
        });
 
        var firstSheet = workbook.SheetNames[0];
        var excelRows = window.XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
 
          for (var i = 0; i < excelRows.length; i++) {
            // window.console.log(  excelRows[i] )
            var nro = excelRows[i].Nro;
            var doc = excelRows[i].documento;
            var nom = excelRows[i].nombres.trim();
            var ap1 = excelRows[i].apellido1.trim();
            var ap2 = excelRows[i].apellido2?excelRows[i].apellido2.trim():"";
            var tel = excelRows[i].telefono1.trim();
            var ema = excelRows[i].email.trim();
            var gen = excelRows[i].genero.trim();
            
            var depastr = excelRows[i].departamento;
            var profstr = excelRows[i].profesion;
            var ciudstr = excelRows[i].ciudad_residencia;

            var depa = vue.getDepartamentos.find( x => x.nombre == depastr)
            var prof = vue.getProfesiones.find( x => x.nombre == profstr)
            var ciud = vue.getCiudades.find( x => x.nombre == ciudstr)
            window.console.log('----',ciudstr,vue.getCiudades)
            var iddepa = -1;
            var idprof = -1;
            var idciud = -1;
            if( depa ) iddepa = depa.codigo;
            if( prof ) idprof = prof.codigo;
            if( ciud ) idciud = ciud.codigo;
            var login = this.crearLogin( nom,ap1,ap2 )
            var clave = this.crearClave( doc,depa )
  
            vue.estudiantes.push( 
              {
                nro:nro,num_doc:doc,nombres:nom,pri_apellido:ap1,
                seg_apellido:ap2,telefono1:tel,email:ema,sexo:gen,
                usuario_moodle: login, clave_moodle: clave,
                tipo:"E",diestro:true,profesiones:[idprof],idciudad:idciud,iddepartamento:iddepa,estado:"SUBIR"
              } 
            );
        }

        // window.console.log( vue.estudiantes )
    },
    async subir(){
      this.subiendo = true;
      var vue = this;
      this.estudiantes.forEach( async function(e,i){
        e.estado = "SUBIENDO...";
        await vue.enviarDatos( e,i );
      })
    },
    async preCargar(){ 
      this.msg = 'Conectando...';
      var sql = gql`query{
        getCiudades{nombre id departamento{nombre} }
        getDepartamentos{nombre id extension}
        getProfesiones{id nombre}
        }`;
      this.$apollo.query({
        query: sql,
      }).then((data) => {
        var datas1 = [];
        var datas2 = [];
        var datas3 = [];
        data.data.getCiudades.forEach( function(e){
          if( !e.departamento ) e.departamento = {nombre:''};
          e.nombre = e.nombre+' ('+e.departamento.nombre+')';
          datas1.push( {nombre:e.nombre,codigo:e.id} );
        })
        data.data.getProfesiones.forEach( function(e){
          datas2.push( {nombre:e.nombre,codigo:e.id} );
        })
        data.data.getDepartamentos.forEach( function(e){
          datas3.push( {nombre:e.nombre,codigo:e.id,extension:e.extension} );
        })
        this.getCiudades = datas1;
        this.getProfesiones = datas2;
        this.getDepartamentos = datas3;
        //window.console.log( datas1,datas2,datas3 );
        this.msg = '';

      }).catch((error) => {
        window.console.error(error);
        this.msg = error;
      })
    },
    async enviarDatos( estudiante,indice ){
      var obj = window.Object.assign({},estudiante);
      delete obj.nro;
      delete obj.estado;
      if( !obj.seg_apellido ) delete obj.seg_apellido

      this.subiendo = true;
      var vue = this;
      var sql = gql`mutation{ createPersona(input:${window.stringifyObject(obj)}){ok,persona{id,num_doc,nombres,pri_apellido,seg_apellido},errors{message}} }`;
      vue.msg = '';
      // window.console.log( sql );

      await this.$apollo.mutate({
        mutation: sql,
      }).then((data) => {
        if(data.data.createPersona.ok){
          // window.console.log( data.data.createPersona )
          var es = vue.estudiantes.find( x => x.num_doc == obj.num_doc )
          if( es ) es.estado = "SUBIDO";
        }else{
          var errores = JSON.stringify(data.data.createPersona.errors);
          var ob = JSON.parse( errores );
          var vals = '';
          ob.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          vue.msg = '';
          //vue.subiendo = false;
          var est = vue.estudiantes.find( x => x.num_doc == obj.num_doc )
          if( est ) est.estado = vals;
          window.console.log( obj,vals )
        }

        if( indice == vue.estudiantes.length -1 ){
          vue.subiendo = false;
        }

      }).catch((error) => {
        if( !error ) return;
        //this.subiendo = false;
        window.console.error(JSON.stringify(error));
        this.$notify( parseJsonError( error ) )
        var est = vue.estudiantes.find( x => x.num_doc == obj.num_doc )
        if( est ) est.estado = error;
      })
    }
  },
  mounted(){
    this.preCargar();
  }
}
</script>